module.exports = "<div class=\"modified-container\" *ngIf=\"item.lastUpdatedDate || item.lastModifiedDate\">\n  <span class=\"category-type\">Modified by</span>:\n  <span *ngIf=\"item.modifiedBy\">{{item.modifiedBy}}</span>\n  <span *ngIf=\"!item.modifiedBy\">Me</span>\n  <span> on {{(item.lastUpdatedDate || item.lastModifiedDate) | amDateFormat:'MM/DD/YYYY'}}</span>\n  <span>{{(item.lastUpdatedDate || item.lastModifiedDate) | amDateFormat:'h:mma'}}</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/popups/my-stuff/modified-by/modified-by.component.html
// module id = ./src/app/components/popups/my-stuff/modified-by/modified-by.component.html
// module chunks = main